import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Pivot, PivotItem, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import get from 'lodash/get';
import { useSelector } from 'react-redux';
import Main from '../../components/Main';
import styles from './AdjustmentListing.style';
import PageTitle from '../../components/PageTitle';
import AdjustmentListTab from '../../components/AdjustmentListTab';
import AdvanceGroupListTab from '../../components/AdvanceGroupListTab';
import AdjustmentsTasksList from '../../components/AdjustmentsTasksList';
import ModuleContentList from '../../components/ModuleContentList';
import ModuleHeader from '../../components/ModuleHeader';
import Module from '../../components/Module';
import { fetchAdjustmentsForReview } from '../../actions/adjustments';
import useAPI from '../../hooks/useAPI';
import { hasRole } from '../../utils/auth';

const AdjustmentListing = () => {
  const { state: locationState, pathname } = useLocation();
  const history = useHistory();
  const [selectedKey, setSelectedKey] = useState('products');

  useEffect(() => {
    if (locationState?.tabName === 'advancegroups') {
      setSelectedKey('advancegroups');
    } else {
      setSelectedKey('adjustments');
    }
  }, [locationState]);

  const tasks = useSelector(state =>
    Object.values(get(state, 'entities.adjustmentsForReview', {})),
  );

  const taskList = useAPI(() => fetchAdjustmentsForReview(), [], {
    disabled: hasRole('partner'),
    fetchOnMount: true,
    autoFetch: false,
  });

  return (
    <>
      <PageTitle>Adjustments</PageTitle>
      <Main>
        {(taskList.error || (tasks && tasks.length > 0)) && (
          <Module>
            <ModuleHeader>Action Required</ModuleHeader>
            {taskList.error && (
              <MessageBar
                isMultiline={false}
                messageBarType={MessageBarType.error}
                messageBarIconProps={{ iconName: 'Info' }}
              >
                Something went wrong while loading adjustments that need review. Please try
                refreshing the page.
              </MessageBar>
            )}

            {tasks.length > 0 && (
              <ModuleContentList>
                <AdjustmentsTasksList items={tasks} isHeaderVisible={false} noBorderBottom />
              </ModuleContentList>
            )}
          </Module>
        )}

        <Pivot
          selectedKey={selectedKey}
          onLinkClick={item => {
            history.push({
              pathname,
              state: { tabName: item.props.itemKey },
            });
          }}
        >
          <PivotItem headerText="Adjustments" itemKey="adjustments" className={styles.item}>
            <AdjustmentListTab hiddenColumns={['totalAmount']} />
          </PivotItem>
          <PivotItem headerText="Advance Groups" itemKey="advancegroups" className={styles.item}>
            <AdvanceGroupListTab hiddenColumns={['balance', 'createdTimestamp']} />
          </PivotItem>
        </Pivot>
      </Main>
    </>
  );
};

export default AdjustmentListing;
